// main.js
import { createApp } from "vue";
import App from "./App.vue";
import "./assets/styles/tailwind.css";
import "./assets/styles/fonts.css";
import router from "./router";
import { createPinia } from "pinia";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/vue-tel-input.css";
import "@fortawesome/fontawesome-free/css/all.css";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { Vue3TagsInput } from "vue3-tags-input";
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueImageZoomer from "vue-image-zoomer";
import "vue-image-zoomer/dist/style.css";

const app = createApp(App);
const pinia = createPinia();

app.use(Toast, {
  position: POSITION.TOP_RIGHT, // or any other position
  timeout: 3000, // Customize as needed
  draggable: true,
});

app.use(VueImageZoomer);

if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
  window.addEventListener("DOMContentLoaded", () => {
    const m = document.querySelector('meta[name="viewport"]');
    if (m) {
      let content = m.getAttribute("content");
      if (!/maximum-scale=1/.test(content)) {
        m.setAttribute("content", content + ", maximum-scale=1");
      }
    }
  });
}

app.component("vue3-tags-input", Vue3TagsInput);
app.component("VueDatePicker", VueDatePicker);
app.use(pinia).use(VueTelInput).use(router).mount("#app");

export { pinia };
